module.exports = __webpack_public_path__ + "static/media/lofi_mark.eab8d53b.png";